/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $) {
	"use strict";

	function iterateHandleTab(item, event, context, iteration) {
		var code = event.keyCode || event.which;

		// If key pressed was not tab, continue
		if (code !== 9) {
			return;
		}

		var allFocusables = $('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]', context).filter(':not([tabindex="-1"])');
		var focusIndex = allFocusables.index(item);

		// If we have iterated the same number of times as there are focusable items, return
		if (iteration === allFocusables.length - 1) {
			return;
		}

		var nextIndex = focusIndex;
		// If shift key is being held, decrement index
		// Otherwise, increment index
		if (event.shiftKey) {
			nextIndex = focusIndex - 1;
		} else {
			nextIndex = focusIndex + 1;
		}

		// If next index is less than 0, wrap around to end
		if (nextIndex < 0) {
			nextIndex = allFocusables.length - 1;
		}

		// If next index is greater than focusables length, wrap around to start
		if (nextIndex >= allFocusables.length) {
			nextIndex = 0;
		}

		var nextItem = allFocusables.eq(nextIndex);

		// If next item is within an "aria-hidden" wrapper, iterate again
		if (nextItem.parents('[aria-hidden="true"]').length > 0) {
			return iterateHandleTab(nextItem, event, context, iteration + 1);
		}

		// Otherwise, focus on next item
		event.stopPropagation();
		event.preventDefault();
		nextItem.focus();
	}

	function handleTab(context) {
		$('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]', context).filter(':not([tabindex="-1"])').on("keydown", function (event) {
			iterateHandleTab($(this), event, context, 0);
		});
	}

	Drupal.behaviors.handleTab = { attach: handleTab };
})(Drupal, jQuery);
